define([ // eslint-disable-line import/no-amd
  'react',
  'underscore',
  'JSON',
  'immutable',
  'js-cookie',
  'lib/sumome/sumolist/formsync',
  'es6!sumo/util',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/form',
  'es6!launcher/util/listbuilder/wysiwyg/dom',
  'es6!launcher/util/listbuilder/embedded/util',
  'es6!launcher/util/constants',
  'es6!launcher/util/listbuilder/constants',
  'es6!launcher/util/listbuilder/stylebuffer/smartbar',
  'es6!launcher/util/discounts/ecommerce',
], (
  React, _, JSON, Immutable, jscookie, FormSync, Util, ListBuilderForm, WysiwygDom, EmbeddedUtil, Constants,
  ListBuilderConstants, SmartBarBuffer, ecommerceUtil,
) => {
  const { FEATURES } = Util.Constants;

  const {
    LIST_BUILDER_3_APP_UUID: APP_ID,
  } = Constants;

  function formatAmount(amount, type, currency) {
    if (type === '%' || !currency.isPrefix) {
      return amount + type;
    }

    return type + amount;
  }

  class SmartBarPopup extends ListBuilderForm {
    constructor(service, settings) {
      super(service, settings);

      this.isClickEmitted = false;
      this.isFormSubmitted = false;
      this.isYielding = false;

      this.onChangeForm = this.onChangeForm.bind(this);
      this.onResize = this.onResize.bind(this);

      this.styleBuffer = _.debounce(this.styleBuffer.bind(this), 100);

      this.smartShow = this.smartShow.bind(this);
      this.smartHide = this.smartHide.bind(this);

      this.onClickPoweredByVariant = this.onClickPoweredByVariant.bind(this);

      this.show = this.show.bind(this);
      this.removeModal = this.removeModal.bind(this);
      this.close = this.close.bind(this);
      this.receivePushApprovalResponse = this.receivePushApprovalResponse.bind(this);
    }

    onClickPoweredByVariant() {
      const powerVariant = 'd003d67a-722b-4c0f-8318-a446bde19b75';
      const refLink = `https://sumome.com/?src=sm-lb-${this.service.api.properties.siteId}&utm_source=sumo-powered-by&utm_medium=list-builder&utm_campaign=${this.service.api.properties.siteId}`;
      const event = `powered-by-click:${APP_ID}:${powerVariant}`;

      this.service.api.emit('event', { appId: '2d1fffc9-378f-4b61-ac79-2dc8a077b827', event });
      window.open(refLink);
    }

    onResize() {
      if (!this.popupEl || this.isYielding) return;

      const position = this.settings.get('position');
      const showType = this.settings.get('show_type');
      SmartBarBuffer.styleBuffer(this.popupEl.querySelector('.sumome-react-wysiwyg-popup-container'), { position, showType });

      if (showType === 'static' && position === 'bottom') {
        this.showStep(this.currentStep);
      } else if (showType === 'smart') {
        const containerEl = this.popupEl.querySelector('.sumome-react-wysiwyg-popup-container');
        containerEl.style[position] = '0px';
        this.smartShow();
      } else if (showType === 'static' && position === 'top') {
        const containerEl = this.popupEl.querySelector('.sumome-react-wysiwyg-popup-container');

        if (containerEl) {
          document.body.style.marginTop = `${containerEl.offsetHeight}px`;
        }
      }
    }

    styleBuffer() {
      if (!this.popupEl || this.isYielding) return;
      const position = this.settings.get('position');
      const showType = this.settings.get('show_type');
      SmartBarBuffer.styleBuffer(this.popupEl.querySelector('.sumome-react-wysiwyg-popup-container'), { position, showType });
    }

    smartShow() {
      if (this.isYielding) return;
      const position = this.settings.get('position');
      SmartBarBuffer.smartShow(this.popupEl.querySelector('.sumome-react-wysiwyg-popup-container'), position);
    }

    smartHide() {
      if (this.isYielding) return;
      const position = this.settings.get('position');
      SmartBarBuffer.smartHide(position);
    }

    staticScroll() {
      if (this.isYielding || !this.popupEl) return;
      SmartBarBuffer.staticScroll(this.popupEl.querySelector('.sumome-react-wysiwyg-popup-container'));
    }

    showDiscountStep = (hasDiscountApplied, subTotal, isClick) => {
      const minPurchaseAmount = this.settings.getIn(['json', 'discount_in_progress', 'min_cart_value']);

      if (hasDiscountApplied) {
        this.showStep('discount_applied');
      } else if (subTotal >= minPurchaseAmount) {
        this.showStep('discount_in_progress');
      } else {
        this.showStep('discount_cart_empty');
      }
      if (!isClick) {
        setTimeout(() => this.pollCart(), 5000);
      }
    }

    getDiscountStep = (subTotal, service, isClick) => {
      const {
        currency = {},
      } = this.service.api.properties.serviceData.listBuilder3Service;

      const symbol = currency.symbol || '$';

      if (this.prevSubTotal !== subTotal) {
        this.prevSubTotal = subTotal;
        const discountCampaigns = this.settings.get('discountCampaigns');
        const sortedDiscounts = discountCampaigns.sort((a, b) => (
          a.get('min_purchase_amount') - b.get('min_purchase_amount')
        ));

        let hasDiscountApplied = false;
        let filteredDiscounts = Immutable.List();

        sortedDiscounts.forEach((discount, index) => {
          if (
            discount.get('min_purchase_amount') <= subTotal
            && index + 1 < sortedDiscounts.size
            && sortedDiscounts.get(index + 1).get('min_purchase_amount') > subTotal
          ) {
            filteredDiscounts = filteredDiscounts.push(discount);
            hasDiscountApplied = true;
          } else if (discount.get('min_purchase_amount') > subTotal) {
            filteredDiscounts = filteredDiscounts.push(discount);
          } else {
            hasDiscountApplied = true;
          }
        });

        const discount = {
          amount: '',
          priceDiff: 0,
          progressToNext: 0,
        };

        if (sortedDiscounts.size) {
          discount.progressToNext = Math.min(
            100,
            Math.round((subTotal / sortedDiscounts.getIn([0, 'min_purchase_amount'])) * 100),
          );
        }

        let discountCampaignId;
        if (filteredDiscounts.size) {
          const firstTier = filteredDiscounts.get(0);
          const secondTier = filteredDiscounts.get(1);
          const discountType = (firstTier.get('discount_type') === 'percentage') ? '%' : symbol;

          discountCampaignId = firstTier.get('id');
          discount.priceDiff = (firstTier.get('min_purchase_amount') - subTotal).toFixed(2);
          discount.amount = formatAmount(firstTier.get('discount_value'), discountType, currency);

          if (secondTier) {
            discount.nextDiscount = {
              priceDiff: (secondTier.get('min_purchase_amount') - subTotal).toFixed(2),
              amount: formatAmount(secondTier.get('discount_value'), discountType, currency),
            };
          }
        } else {
          const highestTier = sortedDiscounts.last();
          const discountType = (highestTier.get('discount_type') === 'percentage') ? '%' : symbol;

          discountCampaignId = highestTier.get('id');
          discount.amount = formatAmount(highestTier.get('discount_value'), discountType, currency);
        }

        if (discount.priceDiff) {
          discount.priceDiff = formatAmount(discount.priceDiff, symbol, currency);
        }

        if (discount.nextDiscount) {
          discount.nextDiscount.priceDiff = formatAmount(
            discount.nextDiscount.priceDiff,
            symbol,
            currency,
          );
        }

        this.settings = this.settings.set('discount', discount);
        const currentDiscountCampaignId = jscookie.get('__smAppliedDiscountCampaignId');
        const currentDiscountId = jscookie.get('__smAppliedDiscountId');
        const { sumoUrl, siteId, visitorId } = this.service.api.properties;

        if (
          currentDiscountCampaignId
          && (
            currentDiscountCampaignId !== discountCampaignId
            || subTotal < sortedDiscounts.first().get('min_purchase_amount')
          )
        ) {
          jscookie.remove('__smAppliedDiscountId');
          jscookie.remove('__smAppliedDiscountCampaignId');
          ecommerceUtil
            .removeDiscountCode({
              siteId,
              campaignId: currentDiscountCampaignId,
              discountId: currentDiscountId,
              sumoUrl,
              service,
              visitorId,
            })
            .then(() => this.showDiscountStep(hasDiscountApplied, subTotal, isClick));
        }

        if (currentDiscountCampaignId !== discountCampaignId && hasDiscountApplied) {
          ecommerceUtil
            .generateDiscountCode({
              siteId,
              campaignId: discountCampaignId,
              sumoUrl,
              service,
              visitorId,
            })
            .then((discountData) => {
              if (discountData && discountData.id) {
                jscookie.set('__smAppliedDiscountId', discountData.id, { path: '/', expires: 7 });
                jscookie.set('__smAppliedDiscountCampaignId', discountCampaignId, { path: '/', expires: 7 });
              }

              this.showDiscountStep(hasDiscountApplied, subTotal, isClick);
            });
        } else {
          this.showDiscountStep(hasDiscountApplied, subTotal, isClick);
        }
      } else if (!isClick) {
        setTimeout(() => this.pollCart(), 5000);
      }
    }

    pollCart = (isClick) => {
      if (this.fetchingCart) return;
      this.fetchingCart = true;

      const service = this.settings.getIn(['discountCampaigns', 0, 'service'], 'shopify');

      ecommerceUtil.getCartSubtotal(service).then((subTotal) => {
        this.fetchingCart = false;
        return this.getDiscountStep(subTotal, service, isClick);
      });
    }

    show() {
      const showPopup = (logEvent = true) => {
        const hasTrackingPixels = this.hasFeature(FEATURES.TRACKING_PIXELS);
        const trackingPixels = this.settings.get('pixels_shown');
        const showType = this.settings.get('show_type');
        const position = this.settings.get('position');

        const shouldYield = this.settings.get('yield');

        if (shouldYield && this.service.api.properties.yield) {
          // Smart Bar only yields to Welcome Mat 2, so wait for that to close if it is available
          const mat = document.querySelector('#sumome-welcomemat');
          const className = mat ? (mat.getAttribute('class') || '') : '';
          if (mat && className.indexOf('sumome-welcomemat-parallax') > -1 && className.indexOf('sumome-welcomemat-embedded') > -1) {
            this.isYielding = true;
            return;
          }
        }

        // Set shown cookie
        setTimeout(() => this.service.setShownCookie(this), 0);

        if (logEvent) {
          this.logEvent('popup');
        }

        this.install();

        if (trackingPixels && hasTrackingPixels) {
          this.addTrackingPixels(trackingPixels, null, { id: 'tracking' });
        }

        if (showType === 'static' && position === 'top') {
          this.staticScroll();
        }
      };

      if (this.settings.hasIn(['json', 'discount_in_progress', 'min_cart_value'])) {
        // Make sure the cart is available first
        const service = this.settings.getIn(['discountCampaigns', 0, 'service'], 'shopify');

        ecommerceUtil
          .getCartSubtotal(service)
          .then(() => {
            const cookieKey = `__smAOVShown${this.settings.get('id')}`;
            const shownCookie = jscookie.get(cookieKey);
            jscookie.set(cookieKey, true, { path: '/', expires: 7 });
            showPopup(!shownCookie);
          })
          .catch((err) => {
            console.log(err);
            console.log('Cart Not Available. Not Installing Smart Bar.');
            this.close();
          });
      } else {
        showPopup();
      }
    }

    install() {
      const showType = this.settings.get('show_type');
      const position = this.settings.get('position');

      // container
      this.popupEl = document.createElement('div');
      this.popupEl.className = 'sumo-form-wrapper smartbar-popup';

      // content
      this.contentEl = document.createElement('div');
      this.contentEl.className = 'smartbar-popup-content';
      this.popupEl.appendChild(this.contentEl);

      document.body.insertBefore(this.popupEl, document.body.childNodes[0]);

      if (this.settings.hasIn(['json', 'discount_in_progress', 'min_cart_value'])) {
        document.addEventListener('click', _.debounce(this.pollCart, 1000, true));
        this.pollCart();
      } else {
        this.showStep(this.currentStep || 'subscribe');
      }

      this.onResize();

      if (showType === 'static' && position === 'top') {
        let height = 0;
        let t = 0;

        this.smartBarCheckInterval = setInterval(() => {
          const smartBarEl = this.popupEl.querySelector('.sumome-smartbar-popup');
          if (smartBarEl) {
            const popupHeight = smartBarEl.offsetHeight;

            if (height !== popupHeight) {
              t = 0;
              this.onResize();
            }

            height = popupHeight;
            t += 10;

            if (t > 3e3) {
              // Assume the smart bar is done jumping around like crazy
              clearInterval(this.smartBarCheckInterval);
            }
          }
        }, 10);
      }
    }
  }

  return SmartBarPopup;
});
